import { styled } from "styled-components";
const TensorGridInputWrapper = styled("div")(
  {
    alignItems: "center",
    cursor: "text",
    display: "flex",
    gap: 8,
    padding: "5px 12px",
    position: "relative",
    width: "100%",
    "&:focus-within": {
      boxShadow: "inset 0 0 0 2px rgba(0,0,0,0.05)"
    },
    "&::after": {
      content: JSON.stringify(""),
      display: "block",
      height: 0,
      position: "absolute"
    }
  },
  ({ $lastRow }) => ({
    "&::after": {
      bottom: $lastRow ? 0 : -1
    }
  }),
  ({ theme, $inputMode, $lastColumn }) => $inputMode ? {
    "&:focus-within::after": {
      backgroundColor: theme.color.blue6,
      height: 3,
      left: -1,
      right: $lastColumn ? 0 : -1
    }
  } : {
    "&:hover::after": {
      backgroundColor: theme.color.monochrome5,
      height: 2,
      left: 0,
      right: 0
    }
  },
  ({ $firstColumn }) => $firstColumn ? {
    paddingLeft: 16
  } : void 0
);
const TensorGridInputImpl = styled("input")(
  ({ theme }) => ({
    appearance: "none",
    background: "none",
    border: 0,
    color: theme.color.default,
    flex: "1 1 0",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.normal,
    lineHeight: theme.lineHeight.default,
    margin: 0,
    minWidth: 0,
    outline: 0,
    padding: 0,
    width: "auto"
  }),
  ({ $align }) => ({ textAlign: $align })
);
export {
  TensorGridInputImpl,
  TensorGridInputWrapper
};
